export default __webpack_public_path__ + "images/by-ed1fb53394827e144c8a4ba1b06e77ed.svg";